import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, Type } from '@angular/core';
import { RenderedSection, SectionEditorBridgeService } from '../../../services/section-editor-bridge.service';
import { Section } from '../../../editor-container/editor-model';
import { BaseSectionEditorDirective } from '../base-section-editor.directive';
import { NbDialogService } from '@nebular/theme';
import { Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PreviewEditStoreService } from '../../../services/preview-edit-store.service';
import { GridCell, RowCell } from '@urbannex/storethemes';
import { EditorDialogComponent } from '../../dialogs/editor-dialog/editor-dialog.component';
import { IframeCommunicationService } from '../../../services/iframe-communication.service';
import { ImageUrlPipe } from './../../../pipes/image-url.pipe';
import { EditState } from '../../../model';

@Component({
  selector: 'kve-banner-editor',
  templateUrl: './banner-editor.component.html',
  styleUrls: ['./banner-editor.component.scss']
})
export class BannerEditorComponent extends BaseSectionEditorDirective implements OnInit, OnChanges {
  @Input() selectedSection: Section;
  @Input() selectedRenderedSection: RenderedSection;
  gridThumbnails: any[];
  gridThumbnails$: Subscription;
  cellIdsThumbs: any[];

  selectedCell: RowCell | GridCell;

  @Output() setListMode = new EventEmitter();

  constructor(sectionEditorBridge: SectionEditorBridgeService,
    private dialogService: NbDialogService,
    private communicator: IframeCommunicationService,
    previewEditStoreService: PreviewEditStoreService) {
    super(sectionEditorBridge, previewEditStoreService)
  }

  goBack(e) {
    this.setListMode.emit();
  }

  open(options: any) {
    // image header footer link
    const action = options["action"];
    const imgSrc = options["imgSrc"];
    const cellId = options["cellId"];

    console.log(options);

    this.previewEditStoreService.setSelectedCell(cellId);

    this.resolveSelectedCell(cellId);
    if (this.selectedCell != null && this.selectedCell != undefined) {
      this.previewEditStoreService.setSelectedCell(this.selectedCell);
    }

    // console.log(options)
    // SampleImageDirectoryComponent
    let component: Type<any> = EditorDialogComponent;
    let title = "Title"
    switch (action) {
      case "image":
        component = EditorDialogComponent;
        title = "Edit Banner"
        break;

      default:
        break;
    }
    this.previewEditStoreService.updateEditState(EditState.EDITING);
    const dialogRef = this.dialogService.open(component, {
      context: {
        title: title,
        imgSrc: imgSrc,
        cellId: cellId,
        section: this.selectedSection,
        selectedCell: this.selectedCell,
        dialogWidth: 960
      },
    })

    dialogRef.onClose.subscribe((resp: GridCell | RowCell) => {
      if (resp != undefined) {
        console.log(resp);
        console.log(this.cellIdsThumbs);
        const activeCell = this.cellIdsThumbs.find(cell => cell.cellId == resp.cellId);
        if (activeCell != null && activeCell != undefined) {
          activeCell.imgSrc = resp.imgSrc;
        }
        this.previewEditStoreService.updateSelectedCell(resp);
        console.log(this.selectedSection);
        this.previewEditStoreService.updateSelectedSection(this.selectedSection);
        console.log("Updating editState to ... ", EditState.UPDATED)
        this.previewEditStoreService.updateEditState(EditState.UPDATED)
      }
    })


  }

  download(e) {
    console.log(e)
    this.communicator.sendFromParent({ id: "dlCellThumb", data: { elId: this.selectedRenderedSection.elementId, cellId: e.cellId } });
    // this.selectedCell.
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.gridThumbnails$ = this.sectionEditorBridge.getSectionThumbnails().pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        console.log(data);
        this.gridThumbnails = data;
      })
    /* this.cellIdsThumbs$ = this.sectionEditorBridge.getCellIdsThumbs().pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      console.log(data);
    }) */
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["selectedSection"]) {
      console.log(this.selectedSection);
    }
    /* if(changes["selectedRenderedSection"]){
      this.elementId = this.selectedRenderedSection.elementId;
    } */
  }

  resolveSelectedCell(cellId) {
    const cells: RowCell[] = this.selectedSection.sectionData.bannerOptions.rowCells;
    if (cells != undefined && cells.length > 0) {
      this.selectedCell = cells.find(cell => cell.cellId == cellId);
      console.log(this.selectedCell);
      // this.communicator.sendFromParent({id:"cellLayout",data:{elId:this.selectedRenderedSection.elementId,section:this.selectedSection,cellId:cellId}});
      // this.selectedCell.
    }
  }

}
